<template>
  <div>
    <div class="card">
      <div class="title">下单人(代表)</div>
      <div>
        <div class="cell">
          <div class="li">姓名</div>
          <div class="licontent">{{userInfo.Name}}</div>
        </div>
        <div class="cell">
          <div class="li">手机号</div>
          <div class="licontent">{{userInfo.Mobile}}</div>
        </div>
        <div class="special" v-if="showBalance">
          <div>
            <div class="lilabel">押金余额</div>
            <div class="livalue">{{userInfo.BalanceDeposit}}</div>
          </div>
          <div>
            <div class="lilabel">租金余额</div>
            <div class="livalue">{{userInfo.BalancePrice}}</div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="card">-->
<!--      <div class="title">寝室成员</div>-->
<!--      <div v-for="(item,index) in memberList" :key="item.Id">-->
<!--        <div class="cell">-->
<!--          <div class="li">姓名</div>-->
<!--          <div class="licontent">{{item.Name}}</div>-->
<!--        </div>-->
<!--        <div class="cell">-->
<!--          <div class="li">手机号</div>-->
<!--          <div class="licontent">{{item.Mobile}}</div>-->
<!--        </div>-->
<!--        <div class="special" v-if="showBalance">-->
<!--          <div>-->
<!--            <div class="lilabel">押金余额</div>-->
<!--            <div class="livalue">{{item.BalanceDeposit}}</div>-->
<!--          </div>-->
<!--          <div>-->
<!--            <div class="lilabel">租金余额</div>-->
<!--            <div class="livalue">{{item.BalancePrice}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <van-divider v-if="index < memberList.length - 1"></van-divider>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {getWeixInfo} from "@/utils/auth";

export default {
  name: 'dormitoryStaffModules',
  props: {
    showBalance: {
      type: Boolean,
      default: ()=>false
    }
  },
  data() {
    return{
      userInfo: {},
      memberList: []
    }
  },
  methods: {
    async getAlLMemberData() {
      try {
        const {Data} = await this.$post('/BizMemberMember/MemberListNotI', {})
        this.memberList = Data
        const newData = JSON.parse(JSON.stringify(Data)).concat([this.userInfo])
        this.$emit('data', newData)
      } catch (e) {

      }
    },
    getUserInfo(){
      this.userInfo = getWeixInfo() ? JSON.parse(getWeixInfo()) : {}
    }
  },
  async mounted(){
    await this.getUserInfo()
    await this.getAlLMemberData()
  }
}


</script>

<style scoped lang="less">
.card{
  margin: 0.2rem;
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  color: #3D3D3D;


  &.special{
    .li{
      width: 60px!important;
    }
  }

  .title{
    color: #333333;
    display: flex;
    font-size: 18px;
    font-weight: bold;
    align-items: center;
  }

  .cell {
    display: flex;
    margin-top: 10px;
    width: 100%;

    >div{
      width: 100%;

      &.li{
        width: 100px;
        flex-shrink: 0;
      }
      &.licontent{
        text-align: right;
      }

      .li-tag{
        display: inline-block;
        color: #ffffff;
        padding: 3px 8px;
        border-radius: 4px;
      }
    }

  }

  .special{
    display: flex;
    margin-top: 10px;
    width: 100%;
    >div{
      width: 100%;
      display: flex;

      &:nth-child(1){
        margin-right: 15px;
        padding-right: 15px;
        border-right: 1px solid #333333;
      }

      >div{
        width: 100%;
      }
      .livalue{
        text-align: right;
      }
    }
  }

  .textarea{
    margin-top: 10px;
    .licontent{
      margin: 5px 0;
      background-color: #FAFAFA;
      padding: 10px;
      word-break: break-all;
      border-radius: 8px;
    }
  }
}
</style>
